// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__l89qe","readonly":"Checkbox_readonly__4wdD6","disabled":"Checkbox_disabled__h5VEk"};